var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isFilterActive
    ? _c(
        "button",
        {
          staticClass: "btn btn-warning rounded-0",
          attrs: { type: "button" },
          on: { click: _vm.resetAllFilters },
        },
        [_c("i", { staticClass: "bi bi-x" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }